import { AppState } from "../types"

export interface ErrorData {
  message: string
  title: string
}

export interface UIModel {
  appState: AppState
  errors: ErrorData[]
}

export const initialUIModel: UIModel = {
  appState: AppState.LOADING,
  errors: [],
}

type UpdateAppState = { type: "UpdateAppState"; payload: AppState }
type AddError = { type: "AddError"; payload: ErrorData }
type ClearError = { type: "ClearError" }

export type UIAction = UpdateAppState | AddError | ClearError

export function uiReducer(model: UIModel, action: UIAction) {
  switch (action.type) {
    case "UpdateAppState":
      return { ...model, appState: action.payload }
    case "AddError":
      return {
        ...model,
        errors: [...model.errors, action.payload],
        appState: AppState.ERROR,
      }
    case "ClearError":
      return {
        ...model,
        errors: [],
        appState: AppState.APP_READY,
      }
  }
}
